
import OrdersDetails from "./dashboard/OrdersDetails";

import SimpleAccordion from "./SimpleAccordion"
import React, { useEffect, useState } from "react";

import axios from "axios";

export default function ManageContent({phone,auth,symb}){

    const [data,setData] = useState([])

    const [isLoad,setIsLoad] = useState(false)
 


    useEffect(()=>{

        axios.get(`https://api.sinatether.com/Auth/get_detail_coin?coin=${symb}`).then((res)=>{


        if (res.data['status'] == 200){



            console.log(res.data)



            setData(res.data['item']['content'])

            setIsLoad(true)


    
    
           
    
    
            
    
            
        }else{

            setIsLoad(true)
        }
    
    
    
    
    }).catch((err)=>{
    
                setIsLoad(true)

      
    })
    

    },[])

   


    return(
        <>

        {isLoad ? 
        
        auth?
        data?
        <>
            <div className={'dkfjsifsuyhrere'}>
            <OrdersDetails phone={phone} auth={auth}/>


        </div>


        <SimpleAccordion title={symb} data={data}/>

  

        </>

        :
        <div className={'dkfjsifsuyhrere'}>
            <OrdersDetails phone={phone} auth={auth}/>


        </div>




        

        :


        data?

            <SimpleAccordion title={symb} data={data}/>
    
       
            
        :
<div className={'dkfjsifsuyhrere'}>
            <OrdersDetails phone={phone} auth={auth}/>


        </div>



        :

        <>
        
        </>


       

    }


        </>
    )
}